import { render, staticRenderFns } from "./ReviewGala.vue?vue&type=template&id=9062bd4a&scoped=true"
import script from "./ReviewGala.vue?vue&type=script&lang=js"
export * from "./ReviewGala.vue?vue&type=script&lang=js"
import style0 from "./ReviewGala.vue?vue&type=style&index=0&id=9062bd4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9062bd4a",
  null
  
)

export default component.exports